// src/components/GlobalModal.js
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import { ReactComponent as CloseIcon } from "assets/img/svg/CrossIcon.svg";

const GlobalModal = ({
  open,
  onClose,
  title,
  content,
  actions,
  maxWidth,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
    >
      <DialogTitle>
        <div style={{fontWeight:"700"}} className="heading-4 color-dark">{title}</div>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>{content}</DialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  );
};

export default GlobalModal;
